/**
 * Template JS
 *
 * JS for WordPress template files.
 * See https://developer.wordpress.org/themes/basics/template-files/.
 */

( function ( $ ) {
	initGlossaryFilter();

	function initGlossaryFilter() {
		$( '#glossarySearchInput' ).on( 'keyup blur', function () {
			const inputValue = $( this ).val();

			// Hide all the results & Cards
			$( '.glossary-results-row ' ).addClass( 'inactive ' );
			$( '.glossary-results-item ' ).hide();

			$( '.glossary-results-row ' ).each( function () {
				$( '.glossary-results-item ' ).each( function () {
					const item = $( this ).attr( 'data-item' );

					if (
						item
							.toUpperCase()
							.indexOf( inputValue.toUpperCase() ) !== -1
					) {
						$( this )
							.parents( '.glossary-results-row ' )
							.removeClass( 'inactive ' );
						$( this ).show();
					}
				} );
			} );
		} );

		$( '.glossary-nav a' ).click( function () {
			const $this = $( this );
			const $nav = $this.attr( 'data-nav' );
			const $parent = $this.parent();
			const $item = $( '.glossary-nav-item' );
			const $row = $( '.glossary-results-row' );

			$( '#glossarySearchInput' ).val( '' );
			$( '.glossary-results-row' ).removeClass( 'inactive' );
			$( '.glossary-results-item' ).show();

			if ( $parent.hasClass( 'active' ) ) {
				$item.removeClass( 'active' );
				$row.removeClass( 'inactive' );
			} else {
				// Remove & Add active class
				$item.removeClass( 'active' );
				$parent.toggleClass( 'active' );

				// Hide all the results
				$row.addClass( 'inactive' );

				// Loop through the row
				$row.each( function () {
					const term = $( this ).attr( 'data-term' );

					if ( $nav === term ) {
						$( this ).removeClass( 'inactive' );
					}
				} );
			}
		} );
	}
} )( jQuery );
